(function() {
  'use strict';

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  function init() {
    var priceEl = document.querySelector('[data-cfc-volume-price]');
    if (!priceEl) return;

    var gridScript = document.querySelector('script[data-cfc-pricing-grid]');
    if (!gridScript) return;

    var grid;
    try {
      grid = JSON.parse(gridScript.textContent);
    } catch (e) {
      return;
    }

    // Find the quantity dropdown (cfc-bulk-qty-selector renders a <select name="quantity">)
    var select = document.querySelector('.cfc-bulk-qty__select[name="quantity"]');
    if (!select) return;

    var totalEl = priceEl.querySelector('[data-cfc-total]');
    var perUnitEl = priceEl.querySelector('[data-cfc-per-unit]');
    if (!totalEl || !perUnitEl) return;

    // Read unit label from the per-unit element's initial text
    var unitLabel = 'card';
    var perUnitMatch = perUnitEl.textContent.match(/per\s+(\w+)/);
    if (perUnitMatch) unitLabel = perUnitMatch[1];

    select.addEventListener('change', function() {
      var qty = parseInt(select.value, 10);
      if (!qty) return;

      var tierPrice = grid[String(qty)];
      if (tierPrice === undefined) return;

      var lineTotal = tierPrice * qty;

      totalEl.textContent = formatter.format(lineTotal);
      perUnitEl.textContent = '(' + formatter.format(tierPrice) + ' per ' + unitLabel + ')';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
